// extracted by mini-css-extract-plugin
export default {"btn":"TotalLoad_btn__JPJf6","bottomLine":"TotalLoad_bottomLine__uAJRK"};